export const wardrobes = [
  {
    slug: "heritage-solidwood",
    index: "01",
    name: "Heritage Solidwood",
    finish: "Solid Wood",
    layout: "Floor-to-ceiling hinged wardrobe",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/jjc105df_IMG_6659.JPG",
    alt: "Heritage Solidwood wardrobe with raised-panel walnut timber shutters",
    description: "Heritage is craftsmanship you can feel — deep walnut-toned solid timber, composed in a classic raised-panel profile with shadow grooves that catch the light through the day. Sealed to protect the surface while preserving the grain, warmth and quiet authority of real wood.",
    materials: ["Solid timber raised-panel shutters", "Natural grain, hand-finished sealant", "Dark metal bar handles", "European soft-close hinges"],
  },
  {
    slug: "noir-atelier",
    index: "02",
    name: "Noir Atelier",
    finish: "PU Finish",
    layout: "Wall-to-wall wardrobe with drawer bank",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/c9wmyts8_IMG_6656%20%282%29.JPG",
    alt: "Noir Atelier wardrobe in charcoal sprayed PU with fluted glass accents",
    description: "Noir Atelier pairs the depth of charcoal sprayed PU — smooth, satin and effortlessly easy to maintain — with fluted glass accents that glow softly against herringbone floors. A drawer bank in the same finish keeps the composition calm, tailored and unmistakably tailored to the room.",
    materials: ["Sprayed PU shutter fronts, satin sheen", "Fluted glass accent panels", "Brass knobs and fittings", "E1-grade, low-emission board core"],
  },
  {
    slug: "nordic-membrane",
    index: "03",
    name: "Nordic Membrane",
    finish: "Membrane",
    layout: "Full-height storage wall",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/8jkufiqe_IMG_6697.jpg",
    alt: "Nordic Membrane storage wall in pale oak-toned seamless shutters",
    description: "Nordic is the quiet one — membrane-pressed shutters wrapped seamlessly over every edge, so the surface flows without a single joint line. The pale oak tone keeps tall walls of storage feeling light, while the wrapped finish shrugs off years of daily touch.",
    materials: ["Membrane-pressed shutters, seamless wrapped edges", "Pale oak woodgrain texture", "Integrated pull detailing", "Moisture-resistant core"],
  },
  {
    slug: "vitrine-profile-glass",
    index: "04",
    name: "Vitrine Profile Glass",
    finish: "Profile Glass",
    layout: "Walk-in display wardrobe",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/bqt1gepy_IMG_6653.JPG",
    alt: "Vitrine Profile Glass walk-in wardrobe with black aluminium frames and lit interior",
    description: "Vitrine turns storage into a gallery — slim black aluminium profiles framing tinted glass, with integrated LED lighting that lets the interior glow like a boutique. Every shelf, rail and drawer stays on display, organised and dust-free behind glass.",
    materials: ["Black anodised aluminium profiles", "Tinted tempered glass shutters", "Integrated LED strip lighting", "Soft-close drawer systems"],
  },
  {
    slug: "walnut-galerie",
    index: "05",
    name: "Walnut Galerie",
    finish: "Solid Wood + Glass",
    layout: "Glass-fronted display wardrobe",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/6ck3eipz_IMG_6805%20%281%29.jpg",
    alt: "Walnut Galerie solid wood wardrobe with reeded glass display shutters",
    description: "Walnut Galerie turns the wardrobe into a curated gallery — solid walnut framing reeded glass that blurs the contents into soft silhouettes, with warm LED light washing every shelf. Folded knits, tailoring and brass objets stay on gentle display behind glass, dust-free and quietly lit.",
    materials: ["Solid walnut frame and shutters", "Reeded glass display panels", "Integrated LED shelf lighting", "Brass knobs, soft-close drawers"],
  },
  {
    slug: "strata",
    index: "06",
    name: "Strata",
    finish: "Ceramic",
    layout: "Sliding wardrobe with mirror bay",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/xlbd0qrf_IMG_6804%20%281%29.jpg",
    alt: "Strata ceramic sliding wardrobe with brass inlay and full mirror bay",
    description: "Strata is stone reimagined for the bedroom — ceramic panels with the depth of quarried limestone, divided by slender brass inlay and a full-height mirror bay that doubles the light. Ceramic shrugs off scratches, sunlight and time, so the wall looks hewn-fresh for decades.",
    materials: ["Ceramic-finish sliding panels", "Brass inlay detailing", "Full-height mirror bay", "Silent-glide sliding hardware"],
  },
  {
    slug: "manor-oak",
    index: "07",
    name: "Manor Oak",
    finish: "Solid Wood, Vintage",
    layout: "Vintage framed wardrobe with drawers",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/lcx4a53s_IMG_6811%20%281%29.jpg",
    alt: "Manor Oak vintage solid wood wardrobe with framed panels and crown moulding",
    description: "Manor Oak carries the soul of an heirloom — vintage-framed solid oak panels beneath a hand-carved crown, catching afternoon sun the way old country houses do. Crystal-cut knobs and deep drawers complete a wardrobe that feels inherited, yet is engineered to modern precision.",
    materials: ["Solid oak framed shutters, vintage profile", "Hand-carved crown moulding", "Crystal-cut knob hardware", "Deep soft-close drawer chest"],
  },
  {
    slug: "corten",
    index: "08",
    name: "Corten",
    finish: "Ceramic, Sliding",
    layout: "Sliding wardrobe with open dresser",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/l01q5h0i_IMG_6797%20%281%29.jpg",
    alt: "Corten bronze ceramic sliding wardrobe revealing a lit open dresser",
    description: "Corten is industrial poetry — bronze ceramic panels with a weathered-metal patina that slide aside to reveal a warm, lit interior of shelves, drawers and hanging rails. The sliding system glides on precision hardware, so a wall of metal-toned stone moves with a fingertip.",
    materials: ["Bronze ceramic sliding panels", "Patinated metal-effect surface", "Lit interior with dresser drawers", "Precision sliding track system"],
  },
  {
    slug: "arcadia",
    index: "09",
    name: "Arcadia",
    finish: "PU + Membrane",
    layout: "Arched wardrobe wall with library niche",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/7lbui49t_IMG_6803%20%281%29.jpg",
    alt: "Arcadia wardrobe wall in cream PU arches with walnut membrane fluting and reeded glass",
    description: "Arcadia is architecture in miniature — cream PU arches floating over walnut membrane fluting, with reeded-glass vitrines and an arched library niche built in. PU gives the arches their flawless satin calm; membrane wraps every flute and curve seamlessly, so the whole wall reads as one crafted piece.",
    materials: ["Cream PU arched shutter fronts", "Walnut membrane fluted panelling", "Reeded-glass arched vitrines", "Integrated library niche with lighting"],
  },
  {
    slug: "nocturne",
    index: "10",
    name: "Nocturne",
    finish: "Profile Glass",
    layout: "Wall-to-wall glass wardrobe",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/1ydmpjv0_IMG_6807%20%281%29.jpg",
    alt: "Nocturne profile glass wardrobe in smoked glass with bronze frames and lit interior",
    description: "Nocturne is the wardrobe as evening ritual — floor-to-ceiling smoked glass in slim bronze profiles, with warm LED light rising through hanging rails, drawer stacks and shelving like a quiet boutique after dark. Everything you own stays visible, organised and beautifully lit, yet softened behind tinted glass.",
    materials: ["Smoked tempered glass shutters", "Slim bronze anodised profiles", "Integrated LED rail and shelf lighting", "Interior drawer stacks, soft-close"],
  },
];
